import { FormattedMessage } from 'react-intl';
import { decamelize } from 'humps';

// STYLES
import { ApiErrorsList, ApiErrorsListItem, ApiErrorsHeader } from './ApiErrors.styles';

function formatKey(key) {
  return decamelize(key, { separator: ' ' });
}

function ApiErrors(props) {
  const { errors, depth } = props;

  if (typeof errors === 'object') {
    if (Array.isArray(errors)) {
      // ARRAY
      return (
        <ApiErrorsList>
          {errors.reduce(
            // @ts-expect-error TS(2786): 'ApiErrors' cannot be used as a JSX component.
            (errorNode, error) => [...errorNode, <ApiErrors key={depth} errors={error} depth={depth + 1} />],
            []
          )}
        </ApiErrorsList>
      );
    } else {
      // OBJECT
      return [
        depth ? null : (
          <ApiErrorsHeader>
            <FormattedMessage id="notification.formErrors" />
          </ApiErrorsHeader>
        ),
        <ApiErrorsList key={depth}>
          {Object.entries(errors).reduce(
            (errorNode, [key, error]) => [
              ...errorNode,
              <ApiErrorsListItem key={depth}>
                <span>
                  {/* @ts-expect-error TS(2786): 'ApiErrors' cannot be used as a JSX component. */}
                  <strong>{formatKey(key)}:</strong> <ApiErrors errors={error} depth={depth + 1} />
                </span>
              </ApiErrorsListItem>,
            ],
            []
          )}
        </ApiErrorsList>,
      ];
    }
  }

  // STRING
  return <ApiErrorsListItem>{String(errors)}</ApiErrorsListItem>;
}

ApiErrors.defaultProps = {
  depth: 0,
};

export default ApiErrors;
